// Packages
import ListItem from 'modules/CustomerStockPrices/components/ListItem';
import PropTypes from 'prop-types';

// Other
import './styles.css';

const CustomerStockPriceList = ({ isLoading, items, onChange, customerId }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='CustomerStockPriceList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No customer stock prices to show here</h3>
		)
	}


	// Data State
	return (
		<div className='CustomerStockPriceList'>

			{items.map((item, index) => {

				return (
					<div className='tr' key={index}>
						<ListItem 
							{...item} 
							isLoading={false}
							onChange={() => {onChange()}}
							customerId={customerId}
						/>
					</div>
				)
				
			})}
	
		</div>
	)
}

CustomerStockPriceList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CustomerStockPriceList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	parent: '',
    parentId: ''
}

export default CustomerStockPriceList;